(function($, undefined) {
	
	'use strict';
	
	var xmlParser = new DOMParser();
	var xmlSerializer = new XMLSerializer();
	
	var XMLToString = function(xml) {
		return xmlSerializer.serializeToString(xml);
	};
	
	var stringToXML = function(XMLstring) {
		return xmlParser.parseFromString(XMLstring, "text/xml");
	};
	
	var addXmlNodeToXmlDoc = function(doc, node, parentTagName) {
		doc.getElementsByTagName(parentTagName)[0].appendChild(node);
	};
	
	var removeNodeFromDocByAttribute = function(doc, parentTagName, attributeName, attributeValue) {
		var nodeToRemove = getXmlNodeByAttribute(doc, parentTagName, attributeName, attributeValue);
		if (nodeToRemove !== null) {
			doc.getElementsByTagName(parentTagName)[0].removeChild(nodeToRemove);
		}
	};
	
	var replaceXmlNodeInXmlDocByAttribute = function(doc, node, parentTagName, attributeName, attributeValue) {		
		var children = doc.getElementsByTagName(parentTagName)[0].childNodes;
		for (let i = 0; i < children.length; i++) {
			if (children[i].getAttribute(attributeName) === attributeValue) {
				doc.documentElement.replaceChild(node, children[i]);
				break;
			}
		}
	};
	
	var getXmlNodeByAttribute = function(doc, parentTagName, attributeName, attributeValue) {
		var item = null;
		var children = doc.getElementsByTagName(parentTagName)[0].childNodes;
		for (let i = 0; i < children.length; i++) {
			if (children[i].getAttribute(attributeName) === attributeValue) {
				item = children[i];
				break;
			}
		}	
		return item;
	};
	
	
	var XMLUtils = Fw.component.export('XMLUtils', {
		XMLToString,
		stringToXML,
		addXmlNodeToXmlDoc,
		removeNodeFromDocByAttribute,
		replaceXmlNodeInXmlDocByAttribute,
		getXmlNodeByAttribute,
	});
	
})(jQuery);
